import { TiktokSpecialStatsItemRow, TiktokSpecialCampaignReport } from '@anytag/graphql';
import { TikTokCampaignReportStats, PostReportSegmentStatus, TikTokCampaignReportRowData } from './types';

const getPostReportStats = (stats?: TiktokSpecialStatsItemRow | null): TikTokCampaignReportStats => ({
  cost: stats?.cost ?? null,
  views: stats?.views ?? null,
  likes: stats?.likes ?? null,
  shares: stats?.shares ?? null,
  adLikes: stats?.adLikes ?? null,
  adReach: stats?.adReach ?? null,
  adShares: stats?.adShares ?? null,
  comments: stats?.comments ?? null,
  followers: stats?.followers ?? null,
  engagement: stats?.engagement ?? null,
  adComments: stats?.adComments ?? null,
  adReachRate: stats?.adReachRate ?? null,
  costsPerLike: stats?.costsPerLike ?? null,
  costsPerView: stats?.costsPerView ?? null,
  adImpressions: stats?.adImpressions ?? null,
  costsPerShare: stats?.costsPerShare ?? null,
  engagementRate: stats?.engagementRate ?? null,
  costsPerComment: stats?.costsPerComment ?? null,
  costsPerFollower: stats?.costsPerFollower ?? null,
  videoPlayActions: stats?.videoPlayActions ?? null,
  adImpressionsRate: stats?.adImpressionsRate ?? null,
  costsPerEngagement: stats?.costsPerEngagement ?? null,
  engagementViewsRate: stats?.engagementViewsRate ?? null
});

export const formatTikTokCampaignReportData = (
  { summary, summaryDaily, average, influencerReports }: TiktokSpecialCampaignReport,
  segmentStatus: PostReportSegmentStatus
) => {
  const rows: TikTokCampaignReportRowData[] = [
    { className: 'total-row', stats: getPostReportStats(summary) }, // Total row
    { className: 'average-row', stats: getPostReportStats(average) } // Average row
  ];

  // Add summary daily rows if segment total is enabled
  if (segmentStatus.total) {
    rows.push(
      ...(summaryDaily?.map<TikTokCampaignReportRowData>(({ date, stats }) => ({
        date,
        className: 'total-daily-row',
        stats: getPostReportStats(stats)
      })) || [])
    );
  }

  // Influencer rows
  influencerReports.forEach(({ summary, summaryDaily, postInfo, influencerInfo }) => {
    // Influencer row
    rows.push({ postInfo, influencerInfo, stats: getPostReportStats(summary) });

    // Add influencer post daily rows if segment post is enabled
    if (segmentStatus.post) {
      rows.push(
        ...(summaryDaily?.map<TikTokCampaignReportRowData>(({ date, stats }) => ({
          date,
          className: 'post-daily-row',
          stats: getPostReportStats(stats)
        })) || [])
      );
    }
  });

  return rows;
};
